import { useEffect, useState } from "react"
import { useForm } from '@laramie/ui';
import { DatePickerCustom, InputNumber, Modal, Select, TableCustom } from "../../common"
import { GetMeses } from "../../../utils/helpers"
import {TIPS} from "../../../consts/tips";
import { getFormatNumber } from "../../../utils/convert";


const RetencionModal = (props) => {

    const entityInit = {
        id: 0,
        idCuenta: 0,
        fechaPresentacion: null,
        anioDeclaracion: '',
        mesDeclaracion: 0,
        numero: 0,
        fechaAlta: null,
        fechaBaja: null,
        retencionItems: []
    };

    const [state, setState] = useState({
        entity: entityInit
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState,
                entity: props.data.entity
            };
        });
        const entity = props.data.entity;
        formSet({
            id: entity.id,
            idCuenta: entity.idCuenta,
            fechaPresentacion: entity.fechaPresentacion,
            anioDeclaracion: entity.anioDeclaracion,
            mesDeclaracion: entity.mesDeclaracion,
            numero: entity.numero,
            fechaAlta: entity.fechaAlta,
            fechaBaja: entity.fechaBaja,
        });
    }
    useEffect(mount, [props.data.entity]);

    const [ formValues, , , formSet ] = useForm({
        id: 0,
        idCuenta: 0,
        fechaPresentacion: null,
        anioDeclaracion: '',
        mesDeclaracion: 0,
        numero: 0,
        fechaAlta: null,
        fechaBaja: null
    })

    return (
        <Modal
            onEscape={props.onCancel}
            show
            size="xl"
            title='Retención'
            tipName={TIPS.NAME.MODALS.RETENCION_MODAL}
            body={(
                <>
                <div className='row form-basic'>
                    <div className="col-6 col-md-3">
                        <label htmlFor="fechaPresentacion" className="form-label">Fecha presentación</label>
                        <DatePickerCustom
                            name="fechaPresentacion"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaPresentacion}
                            disabled={true}
                        />
                    </div>
                    <div className="col-6 col-md-3">
                        <label htmlFor="anioDeclaracion" className="form-label">Año</label>
                        <input
                            name="anioDeclaracion"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={formValues.anioDeclaracion}
                            disabled={true}
                        />
                    </div>
                    <div className="col-6 col-md-3">
                        <label htmlFor="mesDeclaracion" className="form-label">Mes</label>
                        <Select
                            name="mesDeclaracion"
                            className="form-control"
                            value={ formValues.mesDeclaracion }
                            options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                            disabled={true}
                        />
                    </div>
                    <div className="col-6 col-md-3">
                        <label htmlFor="valor" className="form-label">Número</label>
                        <InputNumber
                            name="valor"
                            placeholder=""
                            className="form-control"
                            value={formValues.numero}
                            precision={0}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className='row form-basic'>
                    <TableCustom
                        className="TableCustomBase"
                        data={state.entity.retencionItems}
                        columns={[
                            { Header: 'CUIT', accessor: 'numeroCuitContribuyente', width: '25%', alignCell: 'right' },
                            { Header: 'N° comprobante', accessor: 'numeroComprobante', width: '25%', alignCell: 'right' },
                            { Header: 'Importe retención', accessor: 'importeRetencion', Cell: (props) => getFormatNumber(props.value,2), width: '25%', alignCell: 'right' },
                            { Header: 'Importe base imponible ', accessor: 'importeBaseImponible', Cell: (props) => getFormatNumber(props.value,2), width: '25%', alignCell: 'right' }
                        ]}
                        disabled={true}
                        showFilterGlobal={false}
                    />
                </div>
                </>
            )}

            footer={<>
                <div className="width-100p f-align">
                    <button className="btn back-button" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                </div>
            </>}
        />
    )
}

export default RetencionModal
